import { __extends } from "tslib";
import { GetBucketLifecycleConfigurationOutput, GetBucketLifecycleConfigurationRequest } from "../models/index";
import { deserializeAws_restXmlGetBucketLifecycleConfigurationCommand, serializeAws_restXmlGetBucketLifecycleConfigurationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketLifecycleConfigurationCommand = /** @class */ (function (_super) {
    __extends(GetBucketLifecycleConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketLifecycleConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketLifecycleConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetBucketLifecycleConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetBucketLifecycleConfigurationOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketLifecycleConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketLifecycleConfigurationCommand(input, context);
    };
    GetBucketLifecycleConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketLifecycleConfigurationCommand(output, context);
    };
    return GetBucketLifecycleConfigurationCommand;
}($Command));
export { GetBucketLifecycleConfigurationCommand };
//# sourceMappingURL=GetBucketLifecycleConfigurationCommand.js.map